module.exports = __webpack_public_path__ + "img/Asean.52ae737c.png";